/**
 * Implement Mobile Menu
 * @author Matt Haynes
 * @package Joi Polloi
 */

import debounce from 'lodash.debounce';

const MobileMenu = () => {
    const menuToggle = document.getElementById('mobile-menu-toggle');
    if (!menuToggle) return;

    const toggleMenu = () => {
        menuToggle.classList.toggle('is-active');
        document.body.classList.toggle('mobile-menu-active');

        const menuOpen = document.body.classList.contains('mobile-menu-active');
        if (menuOpen) {
            // Allow time for animation so layout change isn't visiable
            setTimeout(() => {
                document.body.style.position = 'fixed';
                document.body.style.top = `-${window.scrollY}px`;
            }, 400);
        } else {
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
        }
    };

    menuToggle.addEventListener('click', debounce(toggleMenu, 500, {
        leading: true,
        trailing: false,
    }));

    window.addEventListener('resize', debounce(() => {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 768) {
            menuToggle.classList.remove('is-active');
            document.body.classList.remove('mobile-menu-active');
        }
    }, 150));
};

export default MobileMenu;
